import { render, staticRenderFns } from "./DocenteCambiarPassword.vue?vue&type=template&id=0a9d0e1f&scoped=true&"
import script from "./DocenteCambiarPassword.vue?vue&type=script&lang=js&"
export * from "./DocenteCambiarPassword.vue?vue&type=script&lang=js&"
import style0 from "./DocenteCambiarPassword.vue?vue&type=style&index=0&id=0a9d0e1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9d0e1f",
  null
  
)

export default component.exports